module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/button/button.component.html
// module id = 488
// module chunks = 1